import { getIndexPageAdConfig } from './getIndexPageAdConfig';

export const getIndexPageMobileAdConfig = adCount => ({
  ...getIndexPageAdConfig(adCount),
  extraClassNames: {
    '-full-width': true,
    'hide-desktop': true,
  },
});
